import React from 'react';
import sIcon1 from '../../images/icon/ab-page-icon01.svg';
import sIcon2 from '../../images/icon/ab-page-icon02.svg';
import sIcon3 from '../../images/icon/ab-page-icon03.svg';
import sIcon4 from '../../images/icon/ab-page-icon04.svg';

const features = [
    {
        id: 1,
        icon: sIcon1,
        title: "Delivering Excellence",
        content: "At ISL-Tech, delivering excellence means creating cutting-edge software solutions that drive business success."
    },
    {
        id: 2,
        icon: sIcon2,
        title: "Proactive Innovation",
        content: "We anticipate challenges and implement forward-thinking solutions to keep your business ahead of the curve."
    },
    {
        id: 3,
        icon: sIcon3,
        title: "Scalable Growth",
        content: "Our solutions are designed for long-term scalability, ensuring sustainable growth as your business evolves."
    },
    {
        id: 4,
        icon: sIcon4,
        title: "Optimized Performance",
        content: "We prioritize speed and efficiency, delivering robust and high-performing software solutions on time."
    }
];

const FeaturesSection = () => {
    return (
        <section className="fanfact pt-125 pb-125">
            <div className="container">
                <div className="ap-feature_wrap">
                    <div className="row mt-none-30">
                        {features.map((feature, index) => (
                            <div className="col-lg-3 col-md-6 mt-30" key={feature.id}>
                                <div 
                                    className="ap-feature-item wow fadeInUp" 
                                    data-wow-delay={`${index * 100}ms`} 
                                    data-wow-duration="600ms"
                                >
                                    <div className="xb-item--icon">
                                        <img src={feature.icon} alt={feature.title} />
                                    </div>
                                    <h4 className="xb-item--title">{feature.title}</h4>
                                    <p className="xb-item--content">{feature.content}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default FeaturesSection;
